import { Permissions } from '@zspace/roles';
import { DownloadableData } from '@zspace/types';
import { Columns, Element, Section } from 'react-bulma-components';
import BackButton from '../../shared/back-button/back-button';
import SearchBar from '../../ui/search-bar/search-bar';
import { AdminHeaderExport } from './admin-header-export/admin-header-export';
import styles from './admin-header.module.scss';

export type AdminHeaderProps = {
  title: string;
  search: string;
  onSearchChange: (search: string) => void;
  onExport?: (inboxItemId: string) => Promise<DownloadableData<string>>;
  requiredPermissions?: Permissions[];
};

export function AdminHeader({
  title,
  search,
  onSearchChange,
  onExport,
  requiredPermissions = [],
}: AdminHeaderProps) {
  return (
    <Section p={4}>
      <Columns display="flex" alignItems="center" paddingless>
        <Columns.Column
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
        >
          <BackButton />
          <Element display="flex" alignItems="center" className="gap-3">
            <h1 className="is-size-4 has-text-weight-light">{title}</h1>
            <Element className={styles.pill}>
              <h3 className="is-size-7">Admin</h3>
            </Element>
          </Element>
        </Columns.Column>
        <Columns.Column
          display="flex"
          justifyContent="flex-end"
          className="gap-3"
        >
          <AdminHeaderExport
            onExport={onExport}
            requiredPermissions={requiredPermissions}
          />
          <SearchBar
            searchValue={search}
            onChange={onSearchChange}
            debounceMillis={1000}
          />
        </Columns.Column>
      </Columns>
    </Section>
  );
}

export default AdminHeader;
